module.exports = __webpack_public_path__ + "static/media/insertion.d058fc86.png";